import React from 'react';

const ProductNotFound = (props) => (
  <div className="full-message result-message product-expired">

    <div className="image-error-container">
      <img className="img-error" src={require('../assets/error.png')} alt="Icono producto expirado"/>
    </div>

    <h2>El producto fue eliminado o ya no se encuentra disponible</h2>

  </div>
)

export default ProductNotFound



// WEBPACK FOOTER //
// ./client/components/ProductNotFound.js